module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    class: ['mb-4', _vm.borderClass, 'position-relative', 'overflow-hidden'],
    attrs: {
      "shadow-sm": ""
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.loading
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("header-right")], 2) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    staticClass: "small text-muted mb-3"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": _vm.type,
      "height": _vm.height,
      "options": _vm.allOptions,
      "series": _vm.series
    }
  }), _vm._v(" "), (_vm.footer) ? _c('div', {
    staticClass: "mt-2 small text-muted text-center"
  }, [_vm._v(_vm._s(_vm.footer))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d044d1f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/DashboardChart.vue
// module id = 2488
// module chunks = 0